import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { store } from './lib/store/store';
import ScrollToTop from './lib/utils/scrollToTop';
import YandexMetrikaPageViews from './lib/utils/yandexMetrikaPageViews';
import { AppContent } from './components/AppContent/AppContent';
import { AuthProvider } from './context/AuthProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Provider store={store}>
          <AuthProvider>
            <AppContent />
          </AuthProvider>
        </Provider>
        <ScrollToTop />
        <YandexMetrikaPageViews />
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default App;
